import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { BdcBranch } from "../../../types/bdc.type";
import { branchLabel } from "./branches";

/**
 * แถบโหมดทดสอบ — shown while any branch on screen is in test mode, with what that changes: its
 * INVs are TB…, it makes no 7-11 file and its INVs stay out of the register (plan W3).
 */
export default function TestModeBanner({ branches }: Readonly<{ branches: BdcBranch[] }>) {
  const testing = branches.filter((b) => b.is_test_mode);
  if (testing.length === 0) return null;
  return (
    <Alert severity="warning" variant="outlined" sx={{ bgcolor: "#FFF8EC" }} data-testid="bdc-test-mode-banner">
      <AlertTitle sx={{ mb: 0.25 }}>โหมดทดสอบ</AlertTitle>
      {testing.map(branchLabel).join(", ")} อยู่ในโหมดทดสอบ — INV ขึ้นต้น TB… · สร้างไฟล์ส่ง 7-11 ไม่ได้ · ไม่เข้าทะเบียน INV
    </Alert>
  );
}
